import { SafeAreaView } from 'react-native-safe-area-context';
import { styled } from 'dripsy';

export default styled(SafeAreaView)();
